if (!customElements.get('quick-button')) {
  customElements.define('quick-button', class QuickButton extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', this.onClickHandler.bind(this));
    }

    onClickHandler(evt) {
      this.quickModal = document.getElementById('QuickModal');
      this.quickModalContent = document.getElementById('QuickModalContent');
      this.quickModalloader = document.getElementById('QuickModal-loader');
      this.URL = this.dataset.url;

      document.body.classList.add('quickmodal-opened');
      this.quickModalloader.classList.remove('hidden');

      fetch(`${window.location.origin}${this.URL}?view=quick-view`)
      .then((response) => response.text())
      .then((response) => {
        const docHTML = new DOMParser().parseFromString(response, 'text/html');
        console.log(docHTML);
        const sectionHTML = docHTML.querySelector('[data-section-quick-template]').outerHTML;

        this.quickModalloader.classList.add('hidden');
        this.quickModalContent.innerHTML = sectionHTML;
      })
      .catch((e) => {
        console.error(e);
        document.body.classList.remove('quickmodal-opened');
        this.quickModalContent = document.getElementById('QuickModalContent');
        setTimeout( () => {
          this.quickModalContent.innerHTML = '';
        }, 1000);
      })
    }
  });
}

if (!customElements.get('quick-modal')) {
  customElements.define('quick-modal', class QuickModal extends HTMLElement {
    constructor() {
      super();
      
      this.quickModalClose = document.getElementById('QuickModal-close');
      this.quickModalClose.addEventListener('click', this.onClose.bind(this));
    }

    onClose(evt) {
      document.body.classList.remove('quickmodal-opened');
      this.quickModalContent = document.getElementById('QuickModalContent');
      setTimeout( () => {
        this.quickModalContent.innerHTML = '';
      }, 1000);
    }
  });
}
